/* Ball Collage builder — Collage and Wood
   Owns: size selection, live pricing, scale figure, Cloudinary uploads,
   photo-delivery choice, senior-night date, add-to-cart. Reads config from #ic-config.

   2026-09-24: ported the fixes already live on the Identity Series builder
   (assets/identity-collage.js), so this page doesn't repeat bugs we already solved there:
   - scheduleRender(): upload progress re-renders at most once per animation frame.
   - makeThumbnail(): thumbnails are downscaled copies, never full-size phone photos.
   - Thumbnails are updated in place, not rebuilt from scratch on every render.
   - ensureUploadRepaintGuard(): while uploads are in flight, calls window.__cwForceRepaint
     (assets/repaint-guard.js) every 800ms -- the fix for the page going blank during uploads.
   - notifyThemeCartUpdated(): fires the theme's cart event so the header cart updates.
   - Photo 1 / Photo 2 ... cart properties with each Cloudinary URL, matching the Identity
     Series and poster templates (per Crystal).
   - Go to cart after adding (default on, per Crystal).
   - The scale figure only redraws when the size or ball color changes. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ic-builder]');
  if (!root) return;

  var cfgEl = document.getElementById('ic-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var VARIANTS = CFG.variants || {};   // "15" -> { id, price, available }
  var SIZES = CFG.sizes || {};         // "15" -> { label, photos }
  var REF = makeRef();

  var PX_PER_IN = 6;                      // 5'10" figure is 420px tall; viewBox crops to knees-up (55 8 350 350)
  var BALL_CY = { '15': 142, '24': 170 }; // ball centre = grip height

  var state = { size: CFG.defaultSize || '15', ball: CFG.ball || 'Soccer', bg: 'Navy', bgHex: '#121f36', school: '', date: '', rush: false, share: '', uploads: [], busy: false };
  var LIGHT_BG = ['Cream', 'White'];

  function makeRef() {
    var A = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '', i;
    for (i = 0; i < 4; i++) r += A.charAt(Math.floor(Math.random() * A.length));
    var d = new Date(), p = function (n) { return ('0' + n).slice(-2); };
    return 'CW-' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + '-' + r;
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2) + ' USD'; }
  function variant(size) { return VARIANTS[size || state.size] || null; }
  function noun() { return CFG.ballNoun || (state.ball.toLowerCase() + ' ball'); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function photos(size) { return parseInt((SIZES[size] && SIZES[size].photos) || '0', 10) || 0; }
  function sizeLabel(size) { return (SIZES[size] && SIZES[size].label) || (size + ' inch'); }
  function scrub(v) { return String(v == null ? '' : v).replace(/[|=]/g, ' ').trim(); }

  /* ---------- senior night date ---------- */

  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function minDateISO() {
    var d = new Date(), n = 0, lead = CFG.leadBusinessDays || 21;
    d.setHours(0, 0, 0, 0);
    while (n < lead) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n++; }
    return iso(d);
  }
  function pretty(s) {
    var p = s.split('-').map(Number);
    return new Date(p[0], p[1] - 1, p[2]).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }
  function dateProblem(v) {
    if (!v) return '';
    return v < minDateISO() ? 'We need at least ' + (CFG.leadBusinessDays || 21) + ' business days. The earliest date we can promise right now is ' + pretty(minDateISO()) + '.' : '';
  }
  function rushOn() { return state.rush && CFG.rushOffered; }

  /* ---------- scale figure ---------- */

  function figureSvg() {
    var r = Number(state.size) * PX_PER_IN / 2;
    var cy = BALL_CY[state.size] || 150;
    var top = cy - r, bot = cy + r;
    var dimX = Math.min(230 - r - 26, 150);
    var light = LIGHT_BG.indexOf(state.bg) >= 0;
    // Arms drop from the shoulders and wrap in behind the ball; hands sit half-hidden at its sides.
    var lx = 230 - r + 6, rx = 230 + r - 6, hy = cy + 4;
    return '<svg viewBox="55 8 350 350" style="width:100%;height:auto;display:block" role="img" aria-label="Scale drawing of the ' +
      sizeLabel(state.size) + ' ball collage held by a 5 foot 10 adult">' +
      '<g fill="#e7dcc5"><ellipse cx="230" cy="48" rx="21" ry="27"/><rect x="222" y="72" width="16" height="16"/>' +
      '<path d="M205 86 Q184 88 183 110 L188 220 Q189 228 198 228 L262 228 Q271 228 272 220 L277 110 Q276 88 255 86 Z"/>' +
      '<rect x="196" y="222" width="33" height="226" rx="12"/><rect x="231" y="222" width="33" height="226" rx="12"/></g>' +
      '<g stroke="#dccdaf" stroke-width="18" stroke-linecap="round" fill="none">' +
      '<path d="M192 100 Q' + Math.min(180, lx - 8) + ' ' + (hy - 20) + ' ' + lx + ' ' + hy + '"/>' +
      '<path d="M268 100 Q' + Math.max(280, rx + 8) + ' ' + (hy - 20) + ' ' + rx + ' ' + hy + '"/></g>' +
      '<g fill="#dccdaf"><ellipse cx="' + (230 - r - 2) + '" cy="' + hy + '" rx="9" ry="12"/><ellipse cx="' + (230 + r + 2) + '" cy="' + hy + '" rx="9" ry="12"/></g>' +
      '<circle cx="230" cy="' + cy + '" r="' + r + '" fill="' + state.bgHex + '"' + (light ? ' stroke="#cbbb9c" stroke-width="1.5"' : '') + '/>' +
      '<g stroke="#d9a08e" stroke-width="1"><line x1="' + dimX + '" y1="' + top + '" x2="' + dimX + '" y2="' + bot + '"/>' +
      '<line x1="' + (dimX - 6) + '" y1="' + top + '" x2="' + (dimX + 6) + '" y2="' + top + '"/>' +
      '<line x1="' + (dimX - 6) + '" y1="' + bot + '" x2="' + (dimX + 6) + '" y2="' + bot + '"/></g>' +
      '<text x="' + (dimX - 10) + '" y="' + (cy + 5) + '" fill="#a8472c" font-family="Poppins, sans-serif" font-size="17" font-weight="600" letter-spacing="1.53" text-anchor="end">' + state.size + '″</text>' +
      '</svg>';
  }

  /* ---------- uploads (Cloudinary) ---------- */

  function uploadingCount() {
    return state.uploads.filter(function (u) { return u.status === 'uploading'; }).length;
  }

  // Same fix as identity-collage.js: while any upload is in flight, periodically force Chrome
  // to repaint so the page can't get stuck blank. No-ops if repaint-guard.js isn't loaded.
  var uploadRepaintTimer = null;
  function ensureUploadRepaintGuard() {
    if (uploadRepaintTimer) return;
    uploadRepaintTimer = setInterval(function () {
      if (uploadingCount() > 0) {
        if (typeof window.__cwForceRepaint === 'function') window.__cwForceRepaint();
      } else {
        clearInterval(uploadRepaintTimer);
        uploadRepaintTimer = null;
      }
    }, 800);
  }

  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    requestAnimationFrame(function () { renderScheduled = false; render(); });
  }

  function makeThumbnail(file, maxDim) {
    if (typeof createImageBitmap !== 'function') return Promise.resolve(null);
    return createImageBitmap(file).then(function (bitmap) {
      var scale = Math.min(maxDim / bitmap.width, maxDim / bitmap.height, 1);
      var w = Math.max(1, Math.round(bitmap.width * scale));
      var h = Math.max(1, Math.round(bitmap.height * scale));
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(bitmap, 0, 0, w, h);
      if (bitmap.close) bitmap.close();
      return new Promise(function (resolve) {
        if (canvas.toBlob) canvas.toBlob(function (blob) { resolve(blob ? URL.createObjectURL(blob) : null); }, 'image/jpeg', 0.72);
        else resolve(canvas.toDataURL('image/jpeg', 0.72));
      });
    }).catch(function () { return null; });
  }

  function uploadFiles(fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    if (!files.length) return;

    files.forEach(function (f) {
      if (f.size > 10 * 1024 * 1024) { alert(f.name + ' is over 10 MB. Please send a smaller copy.'); return; }
      var item = { id: 'u' + Date.now() + Math.random(), name: f.name, pct: 0, url: '', status: 'uploading', preview: '' };
      state.uploads.push(item);

      makeThumbnail(f, 240).then(function (thumbUrl) {
        item.preview = thumbUrl || URL.createObjectURL(f);
        scheduleRender();
      });

      if (!CFG.cloudName || !CFG.uploadPreset) { item.status = 'pending'; return; }

      ensureUploadRepaintGuard();

      var fd = new FormData();
      fd.append('file', f);
      fd.append('upload_preset', CFG.uploadPreset);
      fd.append('folder', (CFG.cloudFolder || 'ball-collages') + '/' + REF);
      fd.append('tags', REF + ',' + state.ball + ',ball-collage,senior-night');
      fd.append('context', ['ref=' + REF, 'ball=' + scrub(state.ball), 'size=' + state.size + ' inch', 'ball_color=' + scrub(state.bg), 'event_date=' + scrub(state.date)].join('|'));

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + CFG.cloudName + '/upload');
      xhr.upload.onprogress = function (e) { if (e.lengthComputable) { item.pct = Math.round((e.loaded / e.total) * 100); scheduleRender(); } };
      xhr.onload = function () {
        var r = null;
        try { r = JSON.parse(xhr.responseText); } catch (_) {}
        if (r && r.secure_url) { item.status = 'done'; item.pct = 100; item.url = r.secure_url; } else { item.status = 'error'; }
        scheduleRender();
      };
      xhr.onerror = function () { item.status = 'error'; scheduleRender(); };
      xhr.send(fd);
    });

    render();
  }

  /* ---------- add to cart ---------- */

  // Tell the theme's header cart icon / drawer that the cart changed (same as identity-collage.js).
  function notifyThemeCartUpdated(addedItems, addResponseBody) {
    try {
      var ev = new Event('shopify:cart:lines-update', { bubbles: true });
      ev.action = 'add';
      ev.context = 'product';
      ev.lines = addedItems.map(function (it) { return { merchandiseId: 'gid://shopify/ProductVariant/' + it.id, quantity: it.quantity }; });
      var addedList = (addResponseBody && addResponseBody.items) || [];
      var fallbackCount = addedList.reduce(function (sum, it) { return sum + (it.quantity || 0); }, 0);
      ev.promise = fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return { cart: null, detail: { items: addedList, source: 'ball-collage-builder', itemCount: (cart && typeof cart.item_count === 'number') ? cart.item_count : fallbackCount, didError: false } };
        })
        .catch(function () {
          return { cart: null, detail: { items: addedList, source: 'ball-collage-builder', itemCount: fallbackCount, didError: false } };
        });
      document.dispatchEvent(ev);
    } catch (e) { /* never affect the add itself */ }
  }

  function addToCart() {
    var v = variant();
    if (!v || state.busy) return;
    var doneUploads = state.uploads.filter(function (u) { return u.status === 'done' && u.url; });
    var props = {
      'Sport ball': cap(noun()),
      'Ball background color': state.bg,
      'Senior night date': state.date,
      'Photos uploaded': String(doneUploads.length)
    };
    // Per Crystal: list each photo's link in the cart, like the Identity Series and poster templates.
    doneUploads.forEach(function (u, i) { props['Photo ' + (i + 1)] = u.url; });
    if (state.share) props['Photo sharing method'] = state.share;
    if (state.school.trim()) props['School website'] = state.school.trim();
    if (rushOn()) props['Rush production'] = 'Yes, ' + money((CFG.rushFee || 0) * 100);
    props['_photo_ref'] = REF;
    props['_photo_folder'] = (CFG.cloudFolder || 'ball-collages') + '/' + REF;

    var items = [{ id: v.id, quantity: 1, properties: props }];
    state.busy = true; render();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        state.busy = false;
        if (!res.ok) { render(res.body && res.body.description ? res.body.description : 'Something went wrong. Please try again.'); return; }
        document.dispatchEvent(new CustomEvent('ic:added', { detail: res.body }));
        notifyThemeCartUpdated(items, res.body);
        if (CFG.redirectToCart) window.location.href = '/cart';
        else render('Added. We’ll email your proof within 3 business days.');
      })
      .catch(function () { state.busy = false; render('Something went wrong. Please try again.'); });
  }

  /* ---------- render ---------- */

  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function setText(sel, text) { var el = q(sel); if (el) el.textContent = text; }

  var figureKey = '';

  function renderThumbs() {
    var thumbs = q('[data-ic-thumbs]');
    if (!thumbs) return;
    thumbs.hidden = state.uploads.length === 0;
    var existing = {};
    qa('.ic__thumb').forEach(function (el) { existing[el.getAttribute('data-ic-thumb-id')] = el; });
    var seen = {};
    state.uploads.forEach(function (u) {
      seen[u.id] = true;
      var badge = u.status === 'done' ? 'Ready' : u.status === 'error' ? 'Failed' : u.status === 'pending' ? 'Queued' : u.pct + '%';
      var el = existing[u.id];
      if (!el) {
        el = document.createElement('div');
        el.className = 'ic__thumb';
        el.setAttribute('data-ic-thumb-id', u.id);
        el.innerHTML = '<span class="ic__thumb-badge"></span>' +
          '<button type="button" class="ic__thumb-remove" data-ic-remove="' + u.id + '" aria-label="Remove photo">&times;</button>';
        thumbs.appendChild(el);
      }
      if (u.preview && el.getAttribute('data-ic-thumb-src') !== u.preview) {
        el.style.backgroundImage = 'url(' + u.preview + ')';
        el.setAttribute('data-ic-thumb-src', u.preview);
      }
      var badgeEl = el.querySelector('.ic__thumb-badge');
      if (badgeEl && badgeEl.textContent !== badge) badgeEl.textContent = badge;
    });
    Object.keys(existing).forEach(function (id) { if (!seen[id]) existing[id].remove(); });
  }

  function render(statusOverride) {
    var v = variant();
    var need = photos(state.size);
    var added = state.uploads.filter(function (u) { return u.status === 'done' || u.status === 'pending'; }).length;
    var uploading = uploadingCount();

    qa('[data-ic-size]').forEach(function (b) {
      var k = b.getAttribute('data-ic-size');
      b.setAttribute('aria-pressed', k === state.size ? 'true' : 'false');
      var meta = b.querySelector('[data-ic-size-meta]');
      var pv = variant(k);
      if (meta) meta.textContent = 'Holds ' + photos(k) + ' photos · ' + (pv ? money(pv.price) : '—');
    });
    qa('[data-ic-ball]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ic-ball') === state.ball ? 'true' : 'false');
    });
    qa('[data-ic-bg]').forEach(function (b) {
      var on = b.getAttribute('data-ic-bg') === state.bg;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.style.boxShadow = on ? '0 0 0 3px #faf6ee, 0 0 0 5px #be8f35' : 'none';
    });
    setText('[data-ic-bg-name]', 'Selected: ' + state.bg);
    qa('[data-ic-share]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ic-share') === state.share ? 'true' : 'false');
    });

    var key = state.size + '|' + state.bgHex;
    var fig = q('[data-ic-figure]');
    if (fig && key !== figureKey) { fig.innerHTML = figureSvg(); figureKey = key; }
    setText('[data-ic-figure-note]', 'Drawn to scale against a 5\'10" adult. ' + (state.size === '24'
      ? 'The 24 inch covers most of their chest and hips.'
      : 'The 15 inch sits at chest height.') + ' Sides and back are painted black on every collage.');

    setText('[data-ic-photo-headline]', uploading
      ? 'Uploading ' + uploading + ' photo' + (uploading === 1 ? '' : 's') + ', please wait…'
      : (added ? added + ' photos added, tap to add more' : 'Add ' + need + ' photos'));
    setText('[data-ic-upload-note]', CFG.cloudName && CFG.uploadPreset
      ? 'Photos upload straight to our secure studio library, so nothing gets lost in email.'
      : 'Photos are attached to your order and sent to the studio after checkout.');

    renderThumbs();

    var warn = q('[data-ic-photo-warning]');
    if (warn) {
      var short = added > 0 && added < need;
      warn.hidden = !short;
      if (short) warn.textContent = 'You’ve added ' + added + ' of the ' + need + ' photos this size holds. You can check out now and send the rest, or add more above.';
    }

    Array.prototype.slice.call(document.querySelectorAll('[data-ic-faq-photos]')).forEach(function (el) { el.textContent = need; });
    Array.prototype.slice.call(document.querySelectorAll('[data-ic-faq-size]')).forEach(function (el) { el.textContent = sizeLabel(state.size); });

    setText('[data-ic-summary-line]', sizeLabel(state.size) + ' · ' + noun() + ' · ' + state.bg.toLowerCase());
    setText('[data-ic-total]', money((v ? v.price : 0) + (rushOn() ? (CFG.rushFee || 0) * 100 : 0)));

    var dErr = dateProblem(state.date);
    var dateInput = q('[data-ic-date]');
    if (dateInput) dateInput.min = minDateISO();
    setText('[data-ic-date-hint]', 'Dates inside the next ' + (CFG.leadBusinessDays || 21) + ' business days are grayed out. Earliest right now: ' + pretty(minDateISO()) + '.');
    var dateErr = q('[data-ic-date-error]');
    if (dateErr) { dateErr.hidden = !dErr; dateErr.textContent = dErr; }

    var btn = q('[data-ic-atc]');
    var ready = !!v && v.available !== false && !!state.date && !dErr;
    if (btn) { btn.disabled = !ready || state.busy; btn.textContent = state.busy ? 'Adding…' : 'Add to cart'; }

    setText('[data-ic-status]', statusOverride || (!v ? 'This size isn’t available right now.'
      : v.available === false ? 'Sold out in this size right now.'
      : !state.date ? 'Add your senior night date to finish.'
      : dErr ? 'Choose a senior night date we can hit.'
      : cap(noun()) + ' · ' + sizeLabel(state.size) + ' · proof in ' + (rushOn() ? '24 hours' : '3 business days')));
  }

  /* ---------- events ---------- */

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ic-rush-close]')) { var info = q('[data-ic-rush-info]'); if (info) info.hidden = true; return; }
    var t = e.target.closest('[data-ic-bg],[data-ic-size],[data-ic-ball],[data-ic-share],[data-ic-remove],[data-ic-atc],[data-ic-gallery-index]');
    if (!t) return;
    if (t.hasAttribute('data-ic-bg')) { state.bg = t.getAttribute('data-ic-bg'); state.bgHex = t.getAttribute('data-ic-hex'); render(); }
    else if (t.hasAttribute('data-ic-size')) { state.size = t.getAttribute('data-ic-size'); render(); }
    else if (t.hasAttribute('data-ic-ball')) { state.ball = t.getAttribute('data-ic-ball'); render(); }
    else if (t.hasAttribute('data-ic-share')) { var k = t.getAttribute('data-ic-share'); state.share = state.share === k ? '' : k; render(); }
    else if (t.hasAttribute('data-ic-remove')) {
      var id = t.getAttribute('data-ic-remove');
      state.uploads = state.uploads.filter(function (u) { return u.id !== id; });
      render();
    }
    else if (t.hasAttribute('data-ic-atc')) { e.preventDefault(); addToCart(); }
    else if (t.hasAttribute('data-ic-gallery-index')) {
      // Gallery supports images and videos (product.media). Show the picked slide, pause the rest.
      var idx = t.getAttribute('data-ic-gallery-index');
      qa('[data-ic-slide]').forEach(function (sl) {
        var on = sl.getAttribute('data-ic-slide') === idx;
        sl.hidden = !on;
        var vid = sl.querySelector('video');
        if (vid) { try { if (on) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else vid.pause(); } catch (_) {} }
      });
      qa('[data-ic-gallery-index]').forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
    }
  });

  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-ic-school]')) state.school = e.target.value;
  });

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-ic-photos]')) { uploadFiles(e.target.files); e.target.value = ''; }
    else if (e.target.matches('[data-ic-date]')) { state.date = e.target.value; render(); }
    else if (e.target.matches('[data-ic-rush]')) {
      state.rush = e.target.checked;
      var info = q('[data-ic-rush-info]');
      if (info) info.hidden = !state.rush;
      render();
    }
  });

  var dz = q('[data-ic-dropzone]');
  if (dz) {
    ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('is-over'); }); });
    dz.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) uploadFiles(e.dataTransfer.files); });
  }

  render();
})();
